<ng-container *ngIf="vm$ | async as vm">
    <div class="sectionContainer" *ngIf="vm.hasData">
        <h3>Related Projects and Links</h3>
        <table class="projectSectionTable">
            <tr *ngIf="vm.relatedProjects.length > 0">
                <td>
                    projects:
                    <ul class="list-unstyled">
                        <li *ngFor="let relatedProject of vm.relatedProjects">
                            <a (click)="openRelatedProject(relatedProject.projectID, relatedProject.projectName)">
                                {{ relatedProject.projectName }}
                            </a>
                        </li>
                    </ul>
                </td>
            </tr>
            <tr *ngIf="vm.links.length > 0">
                <td>
                    links:
                    <ul class="list-unstyled">
                        <li *ngFor="let link of vm.links">
                            <a [href]="link.url" target="_blank" rel="noopener noreferrer">
                                {{ link.text ? link.text : link.url }}
                            </a>
                        </li>
                    </ul>
                </td>
            </tr>
        </table>
    </div>
</ng-container>
